import React, { useState, useEffect } from "react";
import moment from "moment";
import EventIndicator from "./EventIndicator";
import "../../style/Calendar.css";

const daysOfTheWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];


const Calendar = ({ year, month, events, tags, onDeleteEvent, onDateClick, onUpdateEvent }) => {

  const initialMoment = moment({
    year: year || moment().year(),
    month: month ? month - 1 : moment().month(),
  });
  const [currentMoment, setCurrentMoment] = useState(initialMoment);
  const [containerWidth, setContainerWidth] = useState(window.innerWidth);

  // Update calendar width when window resizes
  useEffect(() => {
    const handleResize = () => setContainerWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const changeMonth = (offset) => {
    setCurrentMoment((prev) => prev.clone().add(offset, "months"));
  };

  const monthName = currentMoment.format("MMMM");
  const currentYear = currentMoment.format("YYYY");

  // Get first and last day of the month
  const firstDayOfMonth = currentMoment.clone().startOf("month");
  const lastDayOfMonth = currentMoment.clone().endOf("month");

  // Get empty spaces before first day
  const firstDayIndex = firstDayOfMonth.isoWeekday() % 7;
  const emptyStartCells = Array.from({ length: firstDayIndex }, () => null);

  // Get days in the month
  const daysInMonth = Array.from({ length: lastDayOfMonth.date() }, (_, i) =>
    firstDayOfMonth.clone().add(i, "days")
  );

  // Fill empty spaces after last day
  let calendarDays = [...emptyStartCells, ...daysInMonth];

  // Ensure rows are in groups of 7
  while (calendarDays.length % 7 !== 0) {
    calendarDays.push(null);
  }

  // **Remove last row if all its values are null**
  let weeks = [];
  for (let i = 0; i < calendarDays.length; i += 7) {
    weeks.push(calendarDays.slice(i, i + 7));
  }

  if (
    weeks.length > 0 &&
    weeks[weeks.length - 1].every((day) => day === null)
  ) {
    weeks.pop(); // Remove last row
  }

  return (
    <div className="calendar-container">
      <div className="calendar-header">
        <button onClick={() => changeMonth(-1)}>❮</button>
        <button onClick={() => changeMonth(1)}>❯</button>
        <h2>
          {monthName} {currentYear}
        </h2>
      </div>

      {/* Use a table for better structure */}
      <table className="calendar-table">
        <thead>
          <tr>
            {daysOfTheWeek.map((day) => (
              <th key={day}>{day}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {weeks.map((week, i) => (
            <tr key={i}>
              {week.map((day, j) => {
                const dayEvents = events.filter((event) =>
                  day ? moment(event.event_date).isSame(day, "day") : false
                );

                return (
                  <td
                    key={j}
                    className={`calendar-day ${day ? "" : "empty"} ${
                      day && day.isSame(moment(), "day") ? "today" : ""
                    }`}
                    onClick={day ? () => onDateClick(day.format("YYYY-MM-DD")) : undefined} // Only allow valid days
                  >
                    {day && <span className="date-number">{day.date()}</span>}
                    <div className="event-container">
                        {dayEvents.map((event) => (
                            <EventIndicator 
                              key={event.id} 
                              event={event} 
                              tags={tags}
                              onDelete={onDeleteEvent} 
                              onUpdate={onUpdateEvent}
                            />
                        ))}
                    </div>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Calendar;